import isNaN from "lodash/isNaN";

export default {
  data() {
    return {
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && (v.length <= 10) && (v.length > 1)) || "Name must be valid",
        (v) => (v && v.length <= 20) || "Name must be less than 10 characters",
      ],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) =>
          /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) || "E-mail must be valid",
      ],
      passwordRules: [
        (v) => !!v || "Password is required",
        (v) =>
          /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}/.test(v) ||
          "Password must contain at least lowercase letter, one number, a special character and one uppercase letter",
      ],
      phoneRules: [
        (v) => !!v || "Phone number is required",
        (v) =>
        /^[0-9]{10}$/.test(v) ||
          "Phone must be valid",
      ],
      tzRules: [
        (v) => !!v || "ID number is required",
        (v) =>
        !this.validateTz(v) ||  "ID must be valid",
      ],
      cardRules: [
        (v) => !!v || "Card number is required",
        (v) =>
        !this.validateCard(v) ||  "Card must be valid",
      ]
    };
  },
  methods: {
    validateTz(numericString) {
      // Returns string error message, or NULL if valid
      if (numericString.length !== 9) return "Must be exactly 9 digits long" // My addition; I don't want <9-digit TZs
      if (numericString.length > 9 || numericString.length < 5) return "Must be between 5 and 9 digits long"
      if (isNaN(Number(numericString))) "Must be numeric"
      
      // Validate the ID number
      numericString = numericString.padStart(9, "0")
      let counter = 0, incNum;
      for (let i = 0; i < 9; i++) {
        incNum = Number(numericString.charAt(i));
        incNum *= (i % 2) + 1;
        if (incNum > 9)
        incNum -= 9;
        counter += incNum;
      }
      if (counter % 10 !== 0) return "Invalid Teudat Zehut number"
      return null
    },
    validateCard(cardNumber) {
      //LUHN algorithm
      let digits = cardNumber.toString().split('').map(Number)
      //if it's an even number
      if(digits.length % 2 === 0) {
        digits = digits.map((digit, idx) => idx % 2 === 0 ? digit * 2 : digit)
      } else {
        digits = digits.map((digit, idx) => idx % 2 === 1 ? digit * 2 : digit)
      }

      //sum the digits
      const sum = digits.reduce((acc, digit) => acc += digit, 0)
      return sum % 10 === 0
    }
  },
  computed: {
    validation() { 
      return this.validateTz(this.userId) 
    },
  }
  
};
